export default __webpack_public_path__ + "img/3851c500e1ef1ada8b312119af813dae.png";